
import React, { Component } from 'react';
import SlideDetails from './SlideDetails';
// add-study-icon_default, remove-study-icon_default
import rightMoveArrow from '../../images/add-study-icon_default.png';
import leftMoveArrow from '../../images/remove-study-icon_default.png';

const CarouselIndicator = ({ index, activeIndex, onClick, indicatorInfo }) => {
  return (
    <li
      title={indicatorInfo}
      onClick={onClick}
      className={
        index == activeIndex
          ? 'carousel__indicator_list--active'
          : 'carousel__indicator_list'
      }
    ><span className="indicator_label">{index + 1}</span>
      <a
        className={
          index == activeIndex
            ? 'carousel__indicator carousel__indicator--active'
            : 'carousel__indicator'
        }
        onClick={onClick}

      />
    </li>
  );
};


// Carousel wrapper component
export default class Carousel extends Component {
  constructor(props) {
    super(props);
    this.goToSlide = this.goToSlide.bind(this);
    this.goToPrevSlide = this.goToPrevSlide.bind(this);
    this.goToNextSlide = this.goToNextSlide.bind(this);
    this.state = {
      activeIndex: 0,
    };
  }

  goToSlide(index) {
    this.setState({
      activeIndex: index,
    });
    this.props.setSelectedSlideIndex(index);
  }

  goToPrevSlide(e) {
    e.preventDefault();
    let index = this.state.activeIndex;
    const { slideCount } = this.props;
    const slidesLength = slideCount.length;
    if (index < 1) {
      index = slidesLength;
    }
    --index;
    this.setState({
      activeIndex: index,
    });
    this.props.setSelectedSlideIndex(index);
  }

  goToNextSlide(e) {
    e.preventDefault();
    let index = this.state.activeIndex;
    const { slideCount } = this.props;
    const slidesLength = slideCount.length - 1;
    if (index === slidesLength) {
      index = -1;
    }
    ++index;
    this.setState({
      activeIndex: index,
    });
    this.props.setSelectedSlideIndex(index);
  }

  render() {
    const { slide, slideCount, indicatorInfo } = this.props;
    const msg = 'Click to move to Slide';
    return (
      <div className="carousel">
        <div className="carousel_arrow" >
          <span className="carousel__arrow carousel__arrow--left">
            <span />
            <img alt="left-arrow"
              onClick={e => this.goToPrevSlide(e)}
              className="carousel-arrow-left"
              src={leftMoveArrow}
              title={`${msg} ${this.state.activeIndex === 0 ? indicatorInfo[slideCount.length - 1].label :
                indicatorInfo[this.state.activeIndex - 1].label}`}
            />
          </span>
          <ul className="carousel__indicators">
            {slideCount.map((slide, index) =>
              <CarouselIndicator
                key={index}
                index={index}
                indicatorInfo={this.props.indicatorInfo[index].label}
                activeIndex={this.state.activeIndex}
                isActive={this.state.activeIndex === index}
                onClick={e => this.goToSlide(index)}
              />
            )}
          </ul>
          <span className="carousel__arrow carousel__arrow--right">
            <span />
            <img alt="right-arrow"
              onClick={e => this.goToNextSlide(e)}
              className="carousel-arrow-right"
              src={rightMoveArrow}
              title={`${msg} ${this.state.activeIndex === slideCount.length - 1 ? indicatorInfo[0].label :
                indicatorInfo[this.state.activeIndex + 1].label}`}
            />
          </span>
        </div>


        <ul className="carousel__slides">
          {slideCount.map(count => {
            if (count === this.state.activeIndex) {
              return (<div>
                <SlideDetails>
                  {<slide.slideName slideOrder={this.state.activeIndex} />}
                </SlideDetails>

              </div>);
            }
          })
          }
        </ul>
      </div>
    );
  }
}

